import OndemandApi from 'common/api/OndemandApi';
import {createFetchListActions} from 'common/actions/utils';
import Address from 'ondemand/types/Address';


export const {
  fetchAgencyAddressesIfNeeded,
  deleteAgencyAddress,
} = createFetchListActions({
  name: 'agency address',
  pluralName: 'agency addresses',
  idProp: 'addressId',
  keys: ['agencyId'],
  DataType: Address,
  api: new OndemandApi(),
});



// WEBPACK FOOTER //
// ./src/ondemand/actions/agencyAddress.js